import { useEffect } from "react";
import BaseTemplate from "components/shared/BaseTemplate";
import Frame from "components/shared/Frame";
import Button from "components/shared/Button";
import { useNavigate, useSearchParams } from "react-router-dom";
import dean from "assets/shared/characters/Dean2.png";
import trackEvent from "services/tracker.service";

export default function IndexPage() {
  const navigate = useNavigate();
  const [query] = useSearchParams();
  localStorage.setItem("referal", query.toString());

  useEffect(() => {
    trackEvent("SIGNUP_WELCOME_INDEX");
  }, []);

  return (
    <BaseTemplate>
      <Frame
        title={
          <>
            <div>Welcome</div>
            <div>To India's Heroic Game Day!</div>
          </>
        }
        showBackBtn={false}
        onBackButtonClick={() => {}}
      >
        <h1 className="sub-heading mb-3">I am a:</h1>

        <div className="d-flex justify-content-evenly flex-wrap ">
          <div className="mb-4 flex flex-row w-full justify-around">
            <Button
              value="Student"
              btnType="green"
              onClick={() => {
                trackEvent("SIGNUP_WELCOME_BUTTON_STUDENT");
                navigate("students");
              }}
            />
            <Button
              value="Parent"
              btnType="green"
              onClick={() => {
                trackEvent("SIGNUP_WELCOME_BUTTON_PARENTS");
                window.location.href = "https://parent.heroicgameday.com/";
              }}
            />
          </div>
          <div className="mb-4 flex flex-row w-full justify-around">
            <Button
              value="Teacher"
              btnType="green"
              onClick={() => {
                trackEvent("SIGNUP_WELCOME_BUTTON_TEACHER");
                navigate("teachers");
              }}
            />
            <Button
              value="School"
              btnType="green"
              onClick={() => {
                trackEvent("SIGNUP_WELCOME_BUTTON_SCHOOL");
                navigate("schools");
              }}
            />
          </div>
        </div>

        <div className="d-flex flex-row justify-content-center">
          <Button
            value="Contact us for help"
            btnType="blue"
            onClick={() => {
              window.open("https://heroicgameday.in/#contact/");
            }}
          />
        </div>
      </Frame>
    </BaseTemplate>
  );
}
